<template>
  <div v-if="show" id="pagebutton">
    <el-button @click="onto(1)">休息室</el-button>
    <el-button @click="onto(7)">休息室641</el-button>
    <el-button @click="onto(2)">发运室</el-button>
    <el-button @click="onto(6)">发运室领导</el-button>
    <el-button @click="onto(3)">查看设备信息</el-button>
    <!-- <el-button @click="onto(4)">动画版本</el-button> -->
    <!-- <el-button @click="onto(5)">跳动到本地</el-button> -->
    <el-button @click="onto(5)">跳动到本地</el-button>
    <el-button @click="reflash">刷新</el-button>
    <el-button @click="getTestWidth">获取宽度</el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    };
  },
  created() {},
  methods: {
    getTestWidth() {
      console.log(document.getElementById("tittleP"));
    },
    reflash() {
      let href = location.href;
      location.reload(href);
    },
    onto(type) {
      if (type == 1) {
        location.replace(
          location.href.split("#")[0] +
            "#" +
            "/rhBigScreen/index?token=share-k71kercjqsa44d5f14tyrhbjy3kcotua&com_id=k71kercjqsa44d5f14tyrhbjy3kcotua&business_id=&audio_paly=1"
        );
      }
      if (type == 7) {
        location.replace(
          location.href.split("#")[0] +
            "#" +
            "/rhBigScreen/index64?token=share-k71kercjqsa44d5f14tyrhbjy3kcotua&com_id=k71kercjqsa44d5f14tyrhbjy3kcotua&business_id=&audio_paly=1"
        );
      }
      if (type == 2) {
        location.replace(
          location.href.split("#")[0] +
            "#" +
            "/rhBigScreen/indexShipment?token=share-k71kercjqsa44d5f14tyrhbjy3kcotua&com_id=k71kercjqsa44d5f14tyrhbjy3kcotua&business_id=&audio_paly=1"
        );
      }
      if (type == 3) {
        location.replace(
          location.href.split("#")[0] + "#" + "/rhBigScreen/devicePage"
        );
      }
      if (type == 4) {
        location.replace(
          location.href.split("#")[0] +
            "#" +
            "/rhBigScreen/indexTmp?token=share-ebrbtfhvbgwj90snu4sp5lhp4tulxf67&com_id=k71kercjqsa44d5f14tyrhbjy3kcotua&business_id="
        );
      }
      if (type == 5) {
        location.replace(
          location.href.split("#")[0] +
            "#" +
            "/rhBigScreen/index?token=share-k71kercjqsa44d5f14tyrhbjy3kcotua&com_id=k71kercjqsa44d5f14tyrhbjy3kcotua&business_id=&audio_paly=1"
        );
      }
      if (type == 6) {
        location.replace(
          location.href.split("#")[0] +
            "#" +
            "/rhBigScreen/indexShipmentlLeader?token=share-k71kercjqsa44d5f14tyrhbjy3kcotua&com_id=&business_id=&token_type=urlonly"
        );
      }
    }
  }
};
</script>
<style lang="less" scoped>
#pagebutton {
  position: fixed;
  left: 310px;
  bottom: 100px;
}
</style>
